/**
 * One shared "which preview is current" counter, across every engine.
 *
 * The Windows voice picker lets someone audition a Denker voice and then a
 * Windows one without leaving the screen, and the two are previewed through
 * different commands in different modules. They still have to supersede each
 * other: whichever was clicked last is the one that should be heard, and the
 * earlier one must resolve as superseded rather than reporting success and
 * relighting its own play icon. A counter private to either module could not
 * see the other's clicks, so it lives here.
 *
 * Deliberately importless, so both the Kokoro and Windows preview paths can
 * depend on it without either depending on the other.
 */

let previewRequestSeq = 0;

/** Take the next request number, superseding any preview already in flight. */
export function claimPreviewRequest(): number {
  previewRequestSeq += 1;
  return previewRequestSeq;
}

/** Whether `requestSeq` is still the newest preview request. */
export function isCurrentPreviewRequest(requestSeq: number): boolean {
  return previewRequestSeq === requestSeq;
}
